import { Component, OnInit } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { AlertController, MenuController, ModalController, NavController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { Store } from '@ngrx/store';
import { Config, General, GlobalErrorResponse, OrganizationCode } from 'merchandising-sdk';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MenuProp } from './stores/menu/menu.prop';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { MiscHelper } from './helpers/misc';
import { App } from '@capacitor/app';
import { Device } from '@capacitor/device';
import Crashes from '@capacitor-community/appcenter-crashes';
import Analytics from '@capacitor-community/appcenter-analytics';
import { LocalNotifications } from '@capacitor/local-notifications'

import { UserProp } from './stores/user/user.prop';
import { setLogin } from './stores/user/user.actions';
import { setDataUpdates } from './stores/menu/menu.actions';
import { version } from 'src/version';
import * as moment from 'moment';
import { NavigationEnd, Router } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(private nav: NavController
    , private storage: Storage
    , private menu: MenuController
    , private alert: AlertController
    , private modal: ModalController
    , private router: Router
    , private store: Store<{ menu: MenuProp, user: UserProp }>) { }

  public has_data_updates: boolean;
  public $menu: Observable<MenuProp>;
  public $user: Observable<UserProp>;
  public orders_count: number = 0;
  public is_data_updates_enabled: boolean;
  public has_manage_order: boolean = false;
  public has_manage_users: boolean = false;
  public has_create_orders: boolean = false;
  public role: string = ''

  public settings: any = {
    logo: "/assets/logos/analyticsmart.png",
    has_orders: true,
    branding: "/assets/logos/analyticsmart.png",
    footer: {
      has_copyright: true
    }
  };
  public is_menu_enabled: boolean;
  public version: string;

  ngOnInit() {
    //  initialize config
    Config.IS_ONLINE = environment.is_online;
    if (!environment.is_online) {
      this.is_data_updates_enabled = true;
    }

    //  initialize store
    this.$menu = this.store.select("menu");
    this.$user = this.store.select("user");

    //  subscribe to user
    this.$user.subscribe(async data => {
      const { is_login } = data;
      this.is_menu_enabled = is_login;
      if (is_login) {
        this.store.dispatch(setDataUpdates({ has_data_updates: false }));
        this.checkRole();
      }
    });

    this.$menu.subscribe(async data => {
      this.has_data_updates = data.has_data_updates;
      if (!environment.is_online) {
        await this.setLocalAssetUrl();
      }
      if (data.has_data_updates) {
        await this.setOrganizationSettings();
      }

      this.orders_count = data.orders_count;
    });

    this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.trackEvent(e)
      }
    })

    this.init();
  }

  async trackEvent (e: any) {
    try{
      await Promise.all([
        this.saveVisitedUrl(e.url),
        // this.saveLocation()
      ])
    }catch(e){
      console.log(`tracking failed`, e)
    }
    await this.ping();
  }

  // async saveLocation (){
  //   const storage = await this.storage.create()
  //   const location = await storage.get(`location`)

  //   const location_treshold_date = moment(new Date()).subtract(`5`, 'minutes')
  //   if (!location || (location && moment(new Date(location.date)).isBefore(location_treshold_date))) {
  //     const coordinates = await Geolocation.getCurrentPosition();
  //     await storage.set(`location`, {
  //       date: new Date().getTime(),
  //       latitude: coordinates.coords.latitude,
  //       longitude: coordinates.coords.longitude
  //     })
  //   }else{
  //     console.log(`Skip saving location`)
  //   }
  // }

  async saveVisitedUrl(url: string) {
    const storage = await this.storage.create()
    let visited_urls: Array<any> = await storage.get(`visited_urls`)
    if (!visited_urls) {
      visited_urls = []
    }
    let is_add = true;
    if (visited_urls.length > 0) {
      const last_visited_url = visited_urls[visited_urls.length - 1]
      if (last_visited_url.url === url) {
        is_add = false;
      }
    }
    if (is_add) {
      visited_urls.push({
        url: url,
        visited_at: new Date().getTime()
      })
      await storage.set(`visited_urls`, visited_urls)
    }
  }

  async ping() {
    const storage = await this.storage.create()
    const last_ping = await storage.get(`last_ping`)
    const visited_urls: Array<any> = await storage.get(`visited_urls`)
    let to_ping = false;
    if (last_ping) {
      const { date } = last_ping
      const treshold_date = moment(new Date()).subtract(`5`, 'minutes')
      if (moment(date).isBefore(treshold_date)) {
        to_ping = true
      }
    } else {
      to_ping = true;
    }

    const is_login = await storage.get(`is_login`)
    if (to_ping && is_login) {
      const orders = await storage.get(`orders`)
      const username = await storage.get(`username`)
      const additional_data: any = {}
      if (visited_urls) {
        additional_data.visited_urls = visited_urls
      }
      const _orders = []
      if(orders && orders.length > 0){
        for(let item of orders){
          _orders.push({
            note: item.note,
            store_id: item.store.id,
            project: item.project,
            components: item.components
          })
        }
      }
      const location = await storage.get(`location`)
      if(location){
        additional_data.location = location
      }
      General.Ping(username, environment.organization, (orders && orders.length > 0) ? 1 : 0, JSON.stringify(additional_data), JSON.stringify(_orders))
      await storage.set(`last_ping`, {
        date: new Date(),
        has_unsync_orders: (orders && orders.length > 0)
      })
      await storage.set(`visited_urls`, [])
    }
    console.log(`to_ping`, to_ping)
  }

  async init() {
    if (!environment.is_online) {
      await Crashes.setEnabled({ enable: true });
      await Analytics.setEnabled({ enable: true });
      await Analytics.startSession();
    }

    App.addListener('appStateChange', change => {
      console.log(`change`, change);
    });

    let storage = await this.storage.create();
    if (await storage.get('is_login')) {
      this.store.dispatch(setLogin({ is_login: true }));
    }
    await this.checkRole();
    await this.setOrganizationSettings();


    //  set app version
    let app_info = null;
    try {
      app_info = await App.getInfo();
      this.version = app_info.version;
    } catch (e) {
      this.version = version.name
    }

    //  check if version is valid for mobile
    this.CheckAppUpdates();

    //  test local notifications
    if (!environment.is_online) {
      const schedule = moment().set({ hour: 23, minutes: 0, seconds: 0 }).toDate();
      await LocalNotifications.schedule({
        notifications: [
          {
            title: `Sync Orders`,
            body: `This is just a friendly reminder for you to sync all the orders you added for today's store visits`,
            id: 1,
            schedule: {
              at: schedule,
              allowWhileIdle: true
            }
          }
        ]
      })
    }

    const user = await this.storage.get(`username`)
    const is_login = await this.storage.get(`is_login`)
    console.log(user, is_login, 'user')

  }

  async CheckAppUpdates() {
    if (!environment.is_online) {
      try {
        const result = await General.CheckStatus(environment.organization);
        const { error } = result as GlobalErrorResponse;
        if (!error) {
          const { version, status } = result as any;
          const release_version = parseInt(version.replace(/\./g, ''));
          const app_version = parseInt(this.version.replace(/\./g, ''));
          if (app_version < release_version) {
            const { platform } = await Device.getInfo();
            if (platform === 'ios') {
              this.showIosUpdate(version);
            }

            if (platform === 'android') {
              this.showAndroidUpdate(version);
            }
          }
        }
      } catch (e) {
        console.log(`Can't access api for now`, e);
      }
    }
  }

  async showIosUpdate(version: string) {
    let app_name = `CI Merchandising`;
    const alert = await this.alert.create({
      header: `Version ${version} is available`,
      message: `Sorry to interupt you, 
                There is an important app update we require you 
                to install before you continue using the app. 
                Go to App Store > Profile Picture Icon (Top Right) 
                > Purchased > Find ${app_name} and click update`,
      buttons: [
        {
          text: `Exit`,
          handler: async () => {
            App.exitApp();
          }
        }
      ],
      backdropDismiss: false
    });
    alert.present();
  }

  async showAndroidUpdate(version: string) {
    let app_name = `CI Merchandising`;
    const alert = await this.alert.create({
      header: `Version ${version} is available`,
      message: `Sorry to interupt you, 
              There is an important app update we require you 
              to install before you continue using the app. 
              Go to Google Play Store or Amazon App Store > Search ${app_name} and click update`,
      buttons: [
        {
          text: `Exit`,
          handler: () => {
            App.exitApp();
          }
        }
      ],
      backdropDismiss: false
    });
    alert.present();
  }

  async redirectToAndroidStore() {
    const env = environment as any;
    let url = '';
    if (environment.organization == OrganizationCode.LOP) {
      url = `https://play.google.com/store/apps/details?id=app.merchandising.lop`;
      if (env.is_apk) {
        url = `https://lop.merchandising.app/download`;
      }
    }

    if (environment.organization == OrganizationCode.GMI) {
      url = `https://play.google.com/store/apps/details?id=app.merchandising.gmi`;
      if (env.is_apk) {
        url = `https://gmi.merchandising.app/download`;
      }
    }

    if (environment.organization == OrganizationCode.CI) {
      url = `https://play.google.com/store/apps/details?id=app.merchandising.ci`;
      if (env.is_apk) {
        url = `https://ci.merchandising.app/download`;
      }
    }
    window.open(url);
  }

  async checkRole() {
    let storage = await this.storage.create();
    const role = await storage.get(`role`);
    this.role = role;
    if (environment.is_online && ['client_admin', 'admin', 'hr'].indexOf(role) > -1) {
      this.has_manage_users = true;
    } else {
      this.has_manage_users = false;
    }

    if (environment.is_online && ['client_admin', 'admin', 'manager'].indexOf(role) > -1) {
      this.has_manage_order = true;
    } else {
      this.has_manage_order = false;
    }

    if (environment.is_online && ['client_admin', 'admin', 'manager', 'merchandiser'].indexOf(role) > -1) {
      this.has_create_orders = true;
    } else {
      this.has_create_orders = false;
    }
  }

  async setOrganizationSettings() {
    const settings = await MiscHelper.getJson('/app/settings.json');
    if (settings) {
      if (settings.menu) {
        if (settings.menu.logo) {
          settings.menu.logo = MiscHelper.getAssetUrl(`/app/${settings.menu.logo}`)
        }
        if (settings.menu.branding) {
          settings.menu.branding = MiscHelper.getAssetUrl(`/app/${settings.menu.branding}`);
        }
      }
      let { menu } = settings;
      this.settings = menu;
    }
  }

  async setLocalAssetUrl() {
    let result = await Filesystem.getUri({
      path: 'repo',
      directory: Directory.Data
    });
    environment.assets_url = Capacitor.convertFileSrc(result.uri);
  }


  pushPage(url: string) {
    this.menu.close();
    this.nav.navigateForward(url);
  }

  rootPage(url: string) {
    this.menu.close();
    this.nav.navigateRoot(url);
  }

  async viewDemoVideo(){
    this.menu.close()
    let filename = `${environment.organization}-merchandising-app-demo.mp4`
    if(environment.organization==='ci' && this.role==='merchandiser'){
      filename = `${environment.organization}-merchandising-app-demo-rep.mp4`
    }
    const url = `https://stmerchandisingprod.z19.web.core.windows.net/${filename}`
    this.nav.navigateForward(`/viewers/video?url=${url}`)
  }

  async logout() {
    let storage = await this.storage.create();
    await storage.remove('is_login');
    await storage.remove(`role`);
    await this.menu.close();
    this.store.dispatch(setLogin({ is_login: false, user: null }));
    this.nav.navigateBack(`/auth/login`);
  }
}